import { VulnerabilitySubStatus, VulnerabilityStatus } from '../api/shared'

export const VULN_STATUS_ALL: VulnerabilityStatus[] = [
  {
    value: 'Confirmed',
    label: 'Confirmed',
    translationId: 'title_vulnerabilityStatusConfirmed'
  },
  {
    value: 'Suspicious',
    label: 'Suspicious',
    translationId: 'title_vulnerabilityStatusSuspicious'
  },
  {
    value: 'NotAProblem',
    label: 'Not a Problem',
    translationId: 'title_vulnerabilityStatusNotProblem'
  },
  {
    value: 'Remediated',
    label: 'Remediated',
    translationId: 'title_vulnerabilityStatusRemediated'
  },
  {
    value: 'AutoRemediated',
    label: 'Remediated - Auto-Verified',
    translationId: 'title_vulnerabilityStatusAutoRemediated'
  },
  {
    value: 'Reported',
    label: 'Reported',
    translationId: 'title_vulnerabilityStatusReported'
  },
  {
    value: 'Fixed',
    label: 'Fixed',
    translationId: 'title_vulnerabilityStatusFixed'
  }
]

export const VULN_OPEN_STATUSES: VulnerabilityStatus[] = [
  {
    value: 'Confirmed',
    label: 'Confirmed',
    translationId: 'title_vulnerabilityStatusConfirmed'
  },
  {
    value: 'Suspicious',
    label: 'Suspicious',
    translationId: 'title_vulnerabilityStatusSuspicious'
  },
  {
    value: 'Reported',
    label: 'Reported',
    translationId: 'title_vulnerabilityStatusReported'
  }
]

export const VULN_CLOSED_STATUSES: VulnerabilityStatus[] = [
  {
    value: 'NotAProblem',
    label: 'Not a Problem',
    translationId: 'title_vulnerabilityStatusNotProblem'
  },
  {
    value: 'Remediated',
    label: 'Remediated',
    translationId: 'title_vulnerabilityStatusRemediated'
  },
  {
    value: 'Fixed',
    label: 'Fixed',
    translationId: 'title_vulnerabilityStatusFixed'
  }
]

export const TRACE_STATUSES: VulnerabilitySubStatus[] = [
  {
    value: 'URL',
    text: 'URL is only accessible by trusted power users',
    translationId: 'detail_vulnerabilitySubstatus_trustedURL'
  },
  {
    value: 'FP',
    text: 'False positive',
    translationId: 'detail_vulnerabilitySubstatus_falsePositive'
  },
  {
    value: 'SC',
    text: 'Goes through an internal security control',
    translationId: 'detail_vulnerabilitySubstatus_internalControl'
  },
  {
    value: 'EC',
    text: 'Attack is defended by an external control',
    translationId: 'detail_vulnerabilitySubstatus_externalControl'
  },
  {
    value: 'OT',
    text: 'Other',
    translationId: 'detail_vulnerabilitySubstatus_other'
  }
]

export const FILTER_GROUPS = {
  SEVERITY: 'SEVERITY',
  VULNERABILITY_RULES: 'ASSESS RULES',
  IMPORTANCE: 'IMPORTANCE',
  APPLICATIONS: 'APPLICATIONS',
  SERVERS: 'SERVERS',
  ENVIRONMENT: 'ENVIRONMENT',
  UNLICENSED: 'UNLICENSED',
  LICENSED: 'LICENSED',
  APP_TAGS: 'APPLICATION TAGS',
  BUILD_NUMBERS: 'BUILD NUMBERS',
  SERVER_TAGS: 'SERVER TAGS',
  VULN_TAGS: 'VULNERABILITY TAGS',
  SECURITY_STANDARDS: 'SECURITY STANDARDS',
  COMPLIANCE_POLICY: 'COMPLIANCE POLICY',
  REMEDIATION_POLICY: 'REMEDIATION POLICY'
}

export const RULE_SEVERITY_LIST = [
  {
    value: 'CRITICAL',
    name: 'Critical',
    translationId: 'title_vulnSeverityTypeCritical',
    group: FILTER_GROUPS.SEVERITY
  },
  {
    value: 'HIGH',
    name: 'High',
    translationId: 'title_vulnSeverityTypeHigh',
    group: FILTER_GROUPS.SEVERITY
  },
  {
    value: 'MEDIUM',
    name: 'Medium',
    translationId: 'title_vulnSeverityTypeMedium',
    group: FILTER_GROUPS.SEVERITY
  },
  {
    value: 'LOW',
    name: 'Low',
    translationId: 'title_vulnSeverityTypeLow',
    group: FILTER_GROUPS.SEVERITY
  },
  {
    value: 'NOTE',
    name: 'Note',
    translationId: 'title_vulnSeverityTypeNote',
    group: FILTER_GROUPS.SEVERITY
  }
]
